module.exports = require('./src/slave_gateway');